// Module
var code = "<div class=bible> <div class=bibletext> <p> </p><h2 class=pn>Psalm&nbsp;20</h2><p><span class=cwvnum>1</span>&nbsp;&nbsp;May the Lord hear you in the day of trouble,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;the name of the God of Jacob defend you;<br> </p> </div></div>";
// Exports
module.exports = code;